import cn from 'classnames';
import React, { PropsWithChildren } from 'react';

export type DSTagSize = 'extra-small' | 'small' | 'medium' | 'large';
export type DSTagColor = 'success' | 'warning' | 'info' | 'error' | 'special' | 'neutral';

interface DSTagProps extends React.HTMLAttributes<HTMLDivElement> {
	size: DSTagSize;
	color: DSTagColor;
}

export const DSTag = (props: PropsWithChildren<DSTagProps>) => {
	const classes = () =>
		cn(
			'inline-flex items-center justify-center',
			'rounded-2',
			'font-semibold whitespace-nowrap',
			{
				'px-1 py-0.5 text-paragraph-xs': props.size === 'extra-small',
				'px-2 py-0.5 text-paragraph-xs': props.size === 'small',
				'px-2 py-0.5 text-paragraph-sm': props.size === 'medium',
				'px-2 py-1 text-paragraph-sm': props.size === 'large',
			},
			{
				'bg-success-600 text-gray-100': props.color === 'success',
				'bg-warning-600 text-gray-100': props.color === 'warning',
				'bg-info-600 text-gray-100': props.color === 'info',
				'bg-error-600 text-gray-100': props.color === 'error',
				'bg-accent-400 text-gray-900': props.color === 'special',
				'bg-primary-100 text-gray-800 dark:bg-dark-300 dark:text-gray-200': props.color === 'neutral',
			},
			props.className,
		);

	return <div className={classes()}>{props.children}</div>;
};
